import { graphql } from 'parkdepot-shared/gql'

const B2C_APPLY_CARPAY_VOUCHER = graphql(`
    mutation B2CApplyCarpayVoucher(
        $order_id: String!
        $code: String!
        $selected_parking_tariff: String
        $parking_context_uuid: String
    ) {
        b2c_apply_discount(
            order_id: $order_id
            code: $code
            selected_parking_tariff: $selected_parking_tariff
            parking_context_uuid: $parking_context_uuid
        ) {
            ...B2COrderResponse
        }
    }
`)

export default B2C_APPLY_CARPAY_VOUCHER
